import styled from 'styled-components';

import { colors, responsive } from '@/utils';

import { controlsFadeTransition } from '../../cameraStreamControls.tokens.ts';

export const StyledProfileGlyph = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.02em;
  color: ${colors.icon.action[100]};
`;

/** Stream quality toggle, stacked directly below the camera switcher in the right-side rail. */
export const StyledStreamProfileToggleHost = styled.div<{
  $visible: boolean;
}>`
  position: relative;
  overflow: hidden;
  border-radius: ${responsive.radius.rounded};

  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  transition:
    background-color ${controlsFadeTransition},
    opacity ${controlsFadeTransition};
`;
